<template>
  <div>
    <section class="banner-gratification" v-if="isHome && isGratification">
      <div id="gratification-container-main">
        <img src="../../assets/images/gratification/nossojeito_esquerdo.png" alt="Unimed Grande Florianópolis"
          class="heart-img" />
        <div class="gratification-content-wrapper">
          <h1>Bonificação 2025 disponível</h1>

          <p class="text-normal">
            Acesse o novo espaço para gerar seu demonstrativo e enviar a nota
            fiscal referente à bonificação.
          </p>

          <p class="text-strong">
            Clique abaixo para acompanhar seus valores, conferir prazos e enviar
            sua NF dentro do período.
          </p>

          <div class="access-button" @click="onClickBannerGratification">
            Acessar Bonificação 2025
          </div>
        </div>
      </div>
    </section>
    <div class="app-content" :class="isAnalitics ? '' : 'app-content-background'">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import RoutesPaths from "../../router/router-structure/routes-paths";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    isAnalitics: {
      get() {
        const teste = this.$route.path.indexOf("analytics") != -1;
        return teste;
      },
    },
    isHome: {
      get() {
        return this.$route.path.indexOf("home") != -1;
      },
    },
    ...mapGetters({
      isGratification: "getGratification",
    }),
  },
  mounted() {
    // const year = 2025;
    // this.$store.dispatch("checkGratifications", year);
  },
  methods: {
    onClickBannerGratification() {
      this.$router.push({
        path: RoutesPaths.gratification.rootName(),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-content {
  height: 89vh;
  width: 100vw;
  padding: 2rem 0rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: percentage($number: 0.6);

  &-background {
    background-image: url("../../assets/images/ilustracao_completa.svg");
  }

  @include media-breakpoint-down(xs) {
    padding: 1.4rem;
  }

  @include media-breakpoint-down(sm) {
    padding: 1.4rem;
  }
}

#gratification-container-main {
  height: 288px;
  background-color: #006b41;
  color: #f4f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  padding: 10px;

  width: 100%;
  overflow: hidden;
}

.gratification-content-wrapper {
  z-index: 0;
  text-align: center;
  margin: 0 auto;
}

.gratification-content-wrapper h1 {
  color: #f4f6f6;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}

.gratification-content-wrapper p {
  color: #f4f6f6;
  font-size: 16px;
  margin-bottom: 10px;
  line-height: 1.4;
  font-weight: 400;
}

.gratification-content-wrapper .text-strong {
  font-weight: 700;
}

.gratification-content-wrapper .text-normal {
  font-weight: 400;
}

.access-button {
  background-color: #f8f9fa;
  color: #212529;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 18px;
  display: inline-block;
  cursor: pointer;
  margin-top: 20px;
}

.heart-img {
  width: 100%;
  max-width: none;
  display: block;
  left: 0;
  right: 0;
  transform-origin: center;
  position: absolute;
  bottom: 20px;
  z-index: 0;
  height: auto;
  max-height: 150px;
  opacity: 0.7;
  box-sizing: border-box;
}

.banner-gratification {
  width: 100%;
}

#loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100px;
  padding: 20px;
}

.loader-circle {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #006b41;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
